// Browser ES6 Polyfill
require('babel-polyfill');

// Start application
require('./main');



// WEBPACK FOOTER //
// ./app/index.js